// extracted by mini-css-extract-plugin
export var tabsWrapper = "HedaCbkd4IUUK_hAA8LQ";
export var withScroll = "XnWOuudPk08rRpsm2hS0";